const BASE_URL = process.env.REACT_APP_API_URL
if (!BASE_URL) console.error('[CONFIG] REACT_APP_API_URL não definido')

function getToken() {
  return localStorage.getItem('zf_token')
}

async function req(path, options = {}) {
  const token = getToken()
  const res = await fetch(`${BASE_URL}${path}`, {
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    ...options,
  })
  if (res.status === 401) {
    localStorage.removeItem('zf_token')
    window.location.reload()
    throw new Error('Sessão expirada')
  }
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: 'Erro desconhecido' }))
    throw new Error(err.error || `Erro ${res.status}`)
  }
  return res.json()
}

export const api = {
  veiculos: {
    listar: () => req('/veiculos'),
    buscar: (id) => req(`/veiculos/${id}`),
    cadastrar: (dados) => req('/veiculos', { method: 'POST', body: JSON.stringify(dados) }),
    atualizar: (id, dados) => req(`/veiculos/${id}`, { method: 'PUT', body: JSON.stringify(dados) }),
    excluir: (id, justificativa) => req(`/veiculos/${id}`, { method: 'DELETE', body: JSON.stringify({ justificativa }) }),
  },
  clientes: {
    listar: () => req('/clientes'),
    buscar: (id) => req(`/clientes/${id}`),
    cadastrar: (dados) => req('/clientes', { method: 'POST', body: JSON.stringify(dados) }),
    atualizar: (id, dados) => req(`/clientes/${id}`, { method: 'PUT', body: JSON.stringify(dados) }),
    excluir: (id, justificativa) => req(`/clientes/${id}`, { method: 'DELETE', body: JSON.stringify({ justificativa }) }),
  },
  contratos: {
    listar: () => req('/contratos'),
    atualizarStatus: (id, status) => req(`/contratos/${id}/status`, { method: 'PATCH', body: JSON.stringify({ status }) }),
    baixar: async (id, nomeArquivo) => {
      const token = getToken()
      const res = await fetch(`${BASE_URL}/contratos/${id}/baixar`, {
        headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
      })
      if (res.status === 401) { localStorage.removeItem('zf_token'); window.location.reload(); throw new Error('Sessão expirada') }
      if (!res.ok) { const err = await res.json().catch(() => ({ error: 'Erro ao baixar' })); throw new Error(err.error) }
      const blob = await res.blob()
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url; a.download = nomeArquivo || `contrato_${id}.docx`; a.click()
      URL.revokeObjectURL(url)
    },
    gerar: async (dados) => {
      const token = getToken()
      const res = await fetch(`${BASE_URL}/contratos/gerar`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify(dados),
      })
      if (res.status === 401) { localStorage.removeItem('zf_token'); window.location.reload(); throw new Error('Sessão expirada') }
      if (!res.ok) { const err = await res.json().catch(() => ({ error: 'Erro ao gerar contrato' })); throw new Error(err.error || `Erro ${res.status}`) }
      return res.blob()
    },
  },
  usuarios: {
    listar: () => req('/usuarios'),
    criar: (dados) => req('/usuarios', { method: 'POST', body: JSON.stringify(dados) }),
    atualizar: (id, dados) => req(`/usuarios/${id}`, { method: 'PATCH', body: JSON.stringify(dados) }),
    excluir: (id, justificativa) => req(`/usuarios/${id}`, { method: 'DELETE', body: JSON.stringify({ justificativa }) }),
    alterarSenha: (senha_atual, nova_senha) => req('/usuarios/me/senha', { method: 'PATCH', body: JSON.stringify({ senha_atual, nova_senha }) }),
  },
  termos: {
    listar: () => req('/termos'),
    baixar: async (id, nomeArquivo) => {
      const token = getToken()
      const res = await fetch(`${BASE_URL}/termos/${id}/baixar`, {
        headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
      })
      if (res.status === 401) { localStorage.removeItem('zf_token'); window.location.reload(); throw new Error('Sessão expirada') }
      if (!res.ok) { const err = await res.json().catch(() => ({ error: 'Erro ao baixar' })); throw new Error(err.error) }
      const blob = await res.blob()
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url; a.download = nomeArquivo || `termo_${id}.docx`; a.click()
      URL.revokeObjectURL(url)
    },
    gerar: async (dados) => {
      const token = getToken()
      const res = await fetch(`${BASE_URL}/termos/gerar`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify(dados),
      })
      if (res.status === 401) { localStorage.removeItem('zf_token'); window.location.reload(); throw new Error('Sessão expirada') }
      if (!res.ok) { const err = await res.json().catch(() => ({ error: 'Erro ao gerar termo' })); throw new Error(err.error || `Erro ${res.status}`) }
      return res.blob()
    },
  },
  notificacoes: {
    gerar: async (dados) => {
      const token = getToken()
      const res = await fetch(`${BASE_URL}/notificacoes/gerar`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify(dados),
      })
      if (res.status === 401) { localStorage.removeItem('zf_token'); window.location.reload(); throw new Error('Sessão expirada') }
      if (!res.ok) { const err = await res.json().catch(() => ({ error: 'Erro ao gerar notificação' })); throw new Error(err.error || `Erro ${res.status}`) }
      return res.blob()
    },
  },
  acordoSerasa: {
    gerar: async (dados) => {
      const token = getToken()
      const res = await fetch(`${BASE_URL}/acordo-serasa/gerar`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify(dados),
      })
      if (res.status === 401) { localStorage.removeItem('zf_token'); window.location.reload(); throw new Error('Sessão expirada') }
      if (!res.ok) { const err = await res.json().catch(() => ({ error: 'Erro ao gerar acordo' })); throw new Error(err.error || `Erro ${res.status}`) }
      return res.blob()
    },
  },
  notaPromissoria: {
    gerar: async (dados) => {
      const token = getToken()
      const res = await fetch(`${BASE_URL}/nota-promissoria/gerar`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify(dados),
      })
      if (res.status === 401) { localStorage.removeItem('zf_token'); window.location.reload(); throw new Error('Sessão expirada') }
      if (!res.ok) { const err = await res.json().catch(() => ({ error: 'Erro ao gerar nota promissória' })); throw new Error(err.error || `Erro ${res.status}`) }
      return res.blob()
    },
  },
  logs: {
    listar: () => req('/logs'),
  },
}
